import { Link } from 'gatsby';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 0 0;

  @media (max-width: 767.98px) {
    padding: 30px 0 0;
  }

  .arrow {
    svg {
      width: 0.875rem;
      fill: black;
    }
  }

  &[dir='ltr'] {
    .arrow {
      svg {
        margin-left: 5px;
      }
    }
  }
  &[dir='rtl'] {
    .arrow {
      svg {
        margin-right: 5px;
      }
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;

  @media (min-width: 578px) {
    max-width: 578px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }
  @media (min-width: 992px) {
    max-width: 992px;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 1.5rem 0 70px;

  @media (max-width: 767.98px) {
    margin: 24px 0 0;
  }
`;

export const Title = styled.span`
  font-family: 'LibreBaskervilleRegular';
  font-size: 20px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: fit-content;
  color: #4a4a4a;
  margin-bottom: 0px;
  padding-bottom: 30px;

  @media (min-width: 768px) {
    font-size: 26px;
    padding-bottom: 0;
  }

  @media (min-width: 1200px) {
    font-size: 30px;
  }
`;

export const RedirectLink = styled(Link)`
  height: 30px;
  width: fit-content;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 12px;
  font-family: 'DINRegular';
  letter-spacing: 2px;
  color: #4a4a4a;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #007bff;
  }

  &.arrow {
    margin: 0 8px;
    color: #4a4a4a;

    &:hover {
      color: #4a4a4a;
    }
  }

  @media (min-width: 767.98px) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const CardsContainer = styled.div`
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  margin: 0;

  @media (min-width: 767.98px) {
    border: none;
  }

  @media (min-width: 1200px) {
    margin-left: -30px;
    margin-right: -30px;
  }
  .slick-slider {
    .slick-slide {
      border-left: 1px solid #ebebeb;

      &:first-child {
        border-left: ${({ dir }) => (dir === 'rtl' ? '' : 'none')};
      }

      @media (max-width: 767.98px) {
        border-left: none;
      }
    }

    .slick-prev {
      @media (max-width: 767.98px) {
        left: -15px;
        z-index: 999;
      }
    }

    .slick-next {
      @media (max-width: 767.98px) {
        right: -15px;
      }
    }

    .slick-dots {
      @media (max-width: 767.98px) {
        padding-top: 0px;
        padding-bottom: 1rem;
      }
    }
  }
`;

export const Card = styled(Link)`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding: 0 30px;
  display: block;

  &:hover {
    .newstitle {
      text-decoration: underline;
    }
  }

  @media (min-width: 992px) {
    margin-bottom: 1.5rem;
  }

  @media (max-width: 991.98px) {
    padding: 0 20px;
  }

  @media (max-width: 849px) and (max-height: 415px) {
    padding: 30px;
    border: 0;
  }

  @media (max-width: 767.98px) {
    padding: 30px;
    border: 0;
  }
`;

export const Date = styled.span`
  display: block;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '10px')};
  color: #000;
  margin-bottom: 1rem;
  margin-top: 0;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : 'DINRegular')};
  text-transform: uppercase;
`;

export const ContentTitle = styled.span`
  margin-bottom: 0;
  color: #000;
  font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'LibreBaskervilleRegular'};
  font-size: ${({ dir }) => (dir === 'rtl' ? '20px' : '16px')};
  line-height: 30px;

  @media (min-width: 768px) {
    font-size: 18px;
  }

  @media (min-width: 1200px) {
    font-size: 20px;
  }
`;

export const ContentDescription = styled.p`
  margin-top: 1rem;
  margin-bottom: 0;
  color: #898989;
  font-size: ${({ dir }) => (dir === 'rtl' ? '13px' : '')};
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : '')};
  @media (max-width: 1200px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: block;
  }
`;
export const CardWrapper = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  padding: 0 !important;
`;
export const LatestNewsMobileLink = styled.div`
  display: none;
  @media (max-width: 767.98px) {
    padding: 30px 0 0;
    display: block;
    text-align: center;
  }
`;
export const LatestNewsLink = styled(Link)`
  &:hover {
    color: #1b7bdd;
    p {
      color: #1b7bdd;
    }
  }
  .arrow {
    width: 14px;
    margin-left: ${({ dir }) => (dir === 'rtl' ? '' : '5px')};
    transform: ${({ dir }) => (dir === 'rtl' ? 'rotate(180deg)' : '')};
    margin-right: ${({ dir }) => (dir === 'rtl' ? '5px' : '')};
  }
  @media (max-width: 767.98px) {
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '2.18px')};
    text-transform: uppercase;
    color: #000;
    display: inline-flex;
  }
  p {
    @media (max-width: 767.98px) {
      margin-bottom: 0px;
      color: #000;
    }
  }
`;
